import React from "react";
import styled from "styled-components";
import emAnaliseIcon from "../../assets/em-analise.png";
import concedidoIcon from "../../assets/concedido.png";
import naoConcedidoIcon from "../../assets/naoConcedido.png";

const LegendContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 2px;
  padding: 15px;
  background: #f2f0f0;
  border-radius: 8px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #555;
  height: 24px;

  &:first-child {
    margin-left: 25px;
  }
`;

const LegendIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

const VagasSolicitadasStatus = () => {
  return (
    <LegendContainer>
      <LegendItem>
        <LegendIcon src={emAnaliseIcon} alt="Em análise" />
        <span>Em análise</span>
      </LegendItem>
      <LegendItem>
        <LegendIcon src={naoConcedidoIcon} alt="Recusado" />
        <span>Recusado</span>
      </LegendItem>
      <LegendItem>
        <LegendIcon src={concedidoIcon} alt="Concedido" />
        <span>Concedido</span>
      </LegendItem>
      <LegendItem>
        <LegendIcon src={concedidoIcon} alt="Confirmado" />
        <span>Confirmado</span>
      </LegendItem>
    </LegendContainer>
  );
};

export default VagasSolicitadasStatus;
